import React from "react";
import Account from "./Account";

function AthleteAccount() {
  return (
    <>
      <div className="bg-gray-100 p-4 h-full pb-24 md:pb-20 xl:pb-6 lg:pb-24 overflow-auto">
        <Account />
      </div>
    </>
  );
}

export default AthleteAccount;
